import PropTypes from 'prop-types';

import { useAccount } from '../../store/account/hooks';
import EmailToolSettings from '../email-settings/EmailToolSettings';
import AlertMessage from '../alerts/AlertMessage';
import StepNavBottom from './StepNavBottom';

const EmailSettingsStep = ({ onPrev, onNext }) => {
  const { account, error, success, setError: setAccountError, setSuccess: setAccountSuccess, loading } = useAccount();

  const isComplete = !!account?.emailPreferences?.senderName && !!account?.emailPreferences?.senderEmail;

  return (
    <div className="m-auto max-w-4xl space-y-12 pb-[60px]">
      <div className="space-y-4">
        <h1 className="text-h1 font-semibold">Email Settings</h1>
        <p className="text-lg">
          Configure your default email sections, sender information, and button styles. These defaults will be applied
          to new campaigns and suggested drafts.
        </p>
      </div>

      <EmailToolSettings />

      <StepNavBottom onPrev={onPrev} onNext={onNext} nextDisabled={!isComplete || loading} />

      <AlertMessage
        open={!!success}
        message={typeof success === 'string' ? success : 'Operation completed successfully!'}
        onClose={() => setAccountSuccess(false)}
        severity="success"
      />

      <AlertMessage
        open={!!error}
        message={typeof error === 'string' ? error : 'Oops, something went wrong!'}
        onClose={() => setAccountError(false)}
        severity="error"
      />
    </div>
  );
};

EmailSettingsStep.propTypes = {
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

export default EmailSettingsStep;
